import { useEffect } from 'react';
import { StatNumber } from '../components/StatNumber.jsx';
import { portfolioContent } from '../content/portfolioContent.js';

const CASE_INDEX = { solar: 0, copilot: 1 };

// The case BRIEF as its own hash-addressable view (#/work/<case>) — the same
// card copy, readable as a page (PM-site parity, owner-approved 2026-07-12):
// teaser (card) → brief → full breakdown. Solar continues into the breakdown;
// Copilot's brief is the whole case.
export function CaseBriefOverlay({ caseKey, onBack, onBreakdown, onContact }) {
  const data = portfolioContent.work.cases[CASE_INDEX[caseKey]];

  useEffect(() => {
    const heading = document.querySelector('.doc-title');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }
  }, [caseKey]);

  return (
    <div className="doc-view case-brief" id="view-case-brief">
      <div className="doc-container">
        <a
          href="#work"
          className="back-link"
          onClick={(event) => {
            event.preventDefault();
            onBack();
          }}
        >
          ← Back to case studies
        </a>
        <span className="eyebrow">Case Study · Brief</span>
        <h1 className="doc-title">{data.title}</h1>
        <p className="byline">{data.meta}</p>
        <div className="case-stat brief-stat">
          <StatNumber target={data.stat.target} suffix={data.stat.suffix} />
          <span className="stat-label">{data.stat.label}</span>
        </div>
        <article className="case-detail-content brief-body">
          {data.detail.map((block) => (
            <div key={block.h}>
              <h4>{block.h}</h4>
              {block.p && <p>{block.p}</p>}
              {block.list && (
                <ul className="decision-list">
                  {block.list.map((item) => (
                    <li key={item.strong}>
                      <strong>{item.strong}</strong>
                      {item.text}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          <p className="case-note">{data.note}</p>
        </article>
        <div className="doc-footer">
          {data.breakdownLink ? (
            <a
              className="btn btn-primary"
              href="#/work/solar/breakdown"
              onClick={(event) => {
                event.preventDefault();
                onBreakdown();
              }}
            >
              Read the full breakdown →
            </a>
          ) : (
            <a
              href="#work"
              onClick={(event) => {
                event.preventDefault();
                onBack();
              }}
            >
              ← Back to case studies
            </a>
          )}
          <a
            href="#contact"
            onClick={(event) => {
              event.preventDefault();
              onContact();
            }}
          >
            Get in touch →
          </a>
        </div>
      </div>
    </div>
  );
}
